import axiosInstance from '../../services/api';

/**
 * Service for managing saved searches
 */
export class SavedSearchService {
  static baseUrl = '/api/saved-searches';

  /**
   * Get all saved searches for a specific type
   * @param {string} searchType - Type of search (active_substance, commercial_product, etc.)
   * @returns {Promise} API response promise
   */
  static async getSavedSearches(searchType) {
    const { data } = await axiosInstance.get(`${this.baseUrl}/`, {
      params: searchType ? { search_type: searchType } : {},
    });
    return data.results || data || [];
  }

  /**
   * Create a new saved search
   * @param {Object} payload - { name, search_type, search_url }
   * @returns {Promise} API response promise
   */
  static async createSavedSearch(payload) {
    const { data } = await axiosInstance.post(`${this.baseUrl}/`, payload);
    return data;
  }

  /**
   * Update a saved search (name only)
   * @param {number} id - Saved search ID
   * @param {string} name - New name
   * @returns {Promise} API response promise
   */
  static async updateSavedSearch(id, name) {
    const { data } = await axiosInstance.patch(`${this.baseUrl}/${id}/`, { name });
    return data;
  }

  /**
   * Delete a saved search
   * @param {number} id - Saved search ID
   * @returns {Promise} API response promise
   */
  static async deleteSavedSearch(id) {
    await axiosInstance.delete(`${this.baseUrl}/${id}/`);
    return true;
  }
}

/**
 * React Query keys for saved searches
 */
export const savedSearchKeys = {
  all: ['savedSearches'],
  lists: () => [...savedSearchKeys.all, 'list'],
  list: (searchType) => [...savedSearchKeys.lists(), searchType],
};

export default SavedSearchService;